import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'tt-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  standalone: true,
  imports: [TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'data-testid': 'tt-snackbar',
  },
})
export class SnackbarComponent {
  public message = input.required<string>();
  public translationParams = input.required<Record<string, string>>({});
  public errorMessage = input<string>('');
}
